var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "up-arrow",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color1, #000)"
    },
    opacity: 0.2,
    d: "M15.77 4.385c-0.381 0.073-0.72 0.339-0.883 0.691l-3.685 7.371c-0.294 0.627 0.071 1.473 0.729 1.689l2.227 0.768v12.822c0 0.643 0.585 1.228 1.228 1.228h1.228c0.643-0 1.228-0.585 1.228-1.228v-12.822l2.227-0.768c0.659-0.216 1.024-1.062 0.729-1.689l-3.685-7.371c-0.216-0.451-0.73-0.74-1.228-0.691-0.038-0.001-0.077-0.001-0.115 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    style: {
      fill: "var(--color1, #000)"
    },
    d: "M15.77 3.156c-0.395 0.078-0.716 0.336-0.88 0.683l-0.003 0.007-3.685 7.371c-0.073 0.153-0.116 0.332-0.116 0.522 0 0.542 0.35 1.001 0.837 1.165l0.009 0.003 2.227 0.768v12.822c0 0.678 0.55 1.228 1.228 1.228h1.228c0.678-0 1.228-0.55 1.228-1.228v0-12.822l2.227-0.768c0.495-0.166 0.846-0.626 0.846-1.167 0-0.189-0.043-0.369-0.119-0.529l0.003 0.007-3.685-7.371c-0.203-0.416-0.622-0.697-1.108-0.697-0.043 0-0.085 0.002-0.126 0.006l0.005-0c-0.017-0.001-0.037-0.001-0.058-0.001s-0.040 0.001-0.060 0.001l0.003-0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    style: {
      fill: "var(--color2, #fefefe)"
    },
    d: "M16 4.385l-3.685 7.371 3.071 1.037v13.705h1.228v-13.705l3.071-1.037z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSprite);
export default __webpack_public_path__ + "static/media/icons_sprite.d6cf8fc288b2d09c546f0a87ed807796.svg";
export { ForwardRef as ReactComponent };